module.exports = __webpack_public_path__ + "static/media/control.46c21a6e.svg";